exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.fade-enter-active,\n.fade-leave-active {\n  -webkit-transition: opacity 0.2s;\n  transition: opacity 0.2s;\n}\n.fade-enter,\n.fade-leave-to {\n  opacity: 0;\n}\n.slide-enter-active,\n.slide-leave-active {\n  -webkit-transition: -webkit-transform 0.5s;\n  transition: -webkit-transform 0.5s;\n  transition: transform 0.5s;\n  transition: transform 0.5s, -webkit-transform 0.5s;\n}\n.slide-enter {\n  -webkit-transform: translateX(100vw);\n          transform: translateX(100vw);\n}\n.slide-leave-active {\n  -webkit-transform: translateX(-100vw);\n          transform: translateX(-100vw);\n}\n", ""]);

// exports
